import * as _ from "lodash";

import {
  IOrderStatus,
  OrderStatusGroupType
} from "src/core/orders/api/orders.api";

/**
 * Get the order status id from the given status code.
 *
 * @param code - The status code.
 * @returns - The status id.
 */
export const getOrderStatusIdFromCode = (orderStatuses: IOrderStatus[], code: string): number | null => {
  const orderStatus = orderStatuses.find(status => status.code === code);

  // If there is no order status found or if it doesn't have an ID, return null
  if (!orderStatus || !orderStatus.id) {
    return null;
  }

  return orderStatus.id;
};

/**
 * Get the order status ids from the given status group.
 *
 * @param group - The status group.
 * @returns - The status ids.
 */
export const getOrderStatusIdsByGroup = (orderStatuses: IOrderStatus[], group: OrderStatusGroupType): number[] | null => {
  return _.map(_.filter(orderStatuses, status => status.settings.group === group), "id");
};

/**
 * Get the order status name from the given status code.
 *
 * @param code - The status code.
 * @returns - The status name.
 */
export const getOrderStatusNameFromCode = (orderStatuses: IOrderStatus[], code: string): string | null => {
  const orderStatus = orderStatuses.find(status => status.code === code);

  // If there is no order status found, return null
  if (!orderStatus) {
    return null;
  }

  return orderStatus.name;
};

/**
 * Get the order status from code
 *
 * @param code - The status code.
 * @returns - The status.
 */
export const getOrderStatusFromCode = (orderStatuses: IOrderStatus[], code: string): IOrderStatus | null => {
  const orderStatus = orderStatuses.find(status => status.code === code);

  // If there is no order status found, return null
  if (!orderStatus) {
    return null;
  }

  return orderStatus;
};

/**
 * Get the order status from id
 *
 * @param orderStatusId - The status id.
 * @returns - The status.
 */
export const getOrderStatusFromId = (orderStatuses: IOrderStatus[], orderStatusId: number): IOrderStatus | null => {
  const orderStatus = orderStatuses.find(status => status.id === orderStatusId);

  // If there is no order status found, return null
  if (!orderStatus) {
    return null;
  }

  return orderStatus;
};
